<template>
    <div>
        <b-card style="width: 100%; margin: 0px; padding: 0px;" no-body>
            <b-card-text>
                <b-card-text v-if="read_only != true">
                    <b-card-header class="d-flex justify-content-between align-items-center py-2">
                        <h6 class="mb-0"></h6>
                        <div class="d-flex align-items-center">
                            <!-- Main Schedule Date Control -->
                            <div class="d-flex align-items-center mr-3">
                                <label class="mb-0 mr-2 text-nowrap">Main Schedule Date:</label>
                                <date-picker
                                    v-model="mainScheduleDate"
                                    format="MM-DD-YYYY"
                                    valueType="format"
                                    placeholder="Select date for all items"
                                    style="width: 150px; margin-right: 10px;"
                                    class="mr-2"
                                ></date-picker>
                            </div>

                            <!-- Main Receiving Location Control -->
                            <div class="d-flex align-items-center">
                                <label class="mb-0 mr-2 text-nowrap">Receiving Location:</label>
                                <b-form-select
                                    v-model="mainReceivingLocation"
                                    :options="filteredLocationsWithDefault"
                                    size="sm"
                                    style="width: 200px; font-size: 12px;"
                                ></b-form-select>
                            </div>
                        </div>
                    </b-card-header>
                </b-card-text>

                <div v-if="items.length > 0" class="diver">
                    <b-card-text v-if="items.length > 0">
                        <table class="text-monospace" style="width: 100%;">
                            <thead>
                                <tr>
                                   
                                    <td class="srr" style="width: 100px;">
                                        PRODUCT SKU
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        DESCRIPTION
                                    </td>
                                     <td class="srr" style="width: 100px;">
                                        INVOICE #
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        CATEGORY
                                    </td>
                                    <td class="srr" style="width: 60px;">
                                        CUBES
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        ORDER QTY
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        SCH QTY
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        RCV QTY
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        STATUS
                                    </td>
                                    <td class="srr" style="width: 150px;">
                                        SCH DATE
                                    </td>
                                    <td class="srr" style="width: 180px;">
                                        RECEIVE LOC
                                    </td>
                                    <td class="srr" style="width: 150px;">
                                        RECEIVE DATE
                                    </td>
                                    <td class="srr" style="width: 150px;">
                                        COMMENTS
                                    </td>
                                    <td class="srr" v-if="read_only != true" style="width: 150px;">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item,idx in items" v-bind:key="idx">
                                 
                                    <td class="srrv">
                                        {{item.product_sku}}
                                    </td>
                                    <td class="srrv">
                                        {{item.product_name}}
                                    </td>
                                       <td class="srrv">
                                        {{item.invoice_id}}
                                    </td>
                                    <td class="srrv">
                                        {{packet.categoriesdict[item.category_id]}}
                                    </td>
                                    <td class="srrv">
                                        {{ item.cubes }}
                                    </td>
                                    <td class="srrv">
                                        <div>
                                            {{item.quantity_ordered}} / {{ item.quantity_received }}
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        <div v-if="read_only != true">
                                            <b-form-input
                                                v-model="item.quantity_scheduled"
                                                size="sm"
                                                type="number"
                                                style="font-size: 11px;"
                                                :min="getMinScheduledQuantity(item)"
                                                :max="item.quantity_ordered"
                                                :disabled="packet.userDetails.userrole != 'admin' || isItemDisabled2(item)"
                                                @input="validateScheduledQuantity(item)"
                                                :state="getScheduledQuantityState(item)"
                                            ></b-form-input>
                                            <b-form-invalid-feedback :state="getScheduledQuantityState(item)">
                                                Must equal ordered quantity when received
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div v-else>
                                            {{item.quantity_scheduled}}
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.quantity_received"
                                            size="sm"
                                            type="number"
                                            style="font-size: 11px;"
                                            :min="getMinQuantity(item)"
                                            :max="item.quantity_ordered"
                                            :disabled="isItemDisabled(item)"
                                            @keydown="preventInvalidEntry($event, item)"
                                            @input="validateQuantity(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            :options="filteredStatuses"
                                            v-model="item.status"
                                            size="sm"
                                            :style="{ backgroundColor: getStatusColor(item.status) }"
                                            :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                            @change="handleStatusChange(item)"
                                            :state="getStatusState(item)"
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        <div style="position: relative; display: inline-block;">
                                            <b-badge
                                                v-if="isScheduleDateFromMain(item)"
                                                variant="info"
                                                style="position: absolute; top: -8px; right: -8px; z-index: 100; font-size: 8px; padding: 2px 4px;"
                                            >
                                                ETA
                                            </b-badge>
                                            <date-picker
                                                v-model="item.schedule_date"
                                                format="MM-DD-YYYY"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px;"
                                                @change="handleScheduleDateChange(item)"
                                            ></date-picker>
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            :options="filteredLocationsWithDefault"
                                            v-model="item.locsub"
                                            size="sm"
                                            style="font-size: 11px;"
                                            :disabled="isItemDisabled(item)"
                                            :state="getLocationState(item)"
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        <date-picker
                                            v-model="item.receiving_date"
                                            format="MM-DD-YYYY"
                                            valueType="format"
                                            style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px;"
                                            :disabled="(isWarehouseUser && [1,2,3,4,5,6,7,8].includes(item.status)) || isItemDisabled(item) || isItemDisabled2(item)"
                                        ></date-picker>
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.comments"
                                            size="sm"
                                            type="text"
                                            style="font-size: 11px;"
                                            :disabled="isItemDisabled(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv" v-if="read_only != true">
                                        <div style="display: flex; align-items: center; justify-content: center; gap: 5px; flex-wrap: nowrap;">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                @change="handleImageUpload($event, item, idx)"
                                                style="display: none;"
                                                :ref="'fileInput-' + idx"
                                                :disabled="isItemDisabled(item)"
                                            >
                                            <b-button
                                                v-if="!item.images || item.images.length === 0"
                                                size="sm"
                                                variant="outline-primary"
                                                @click="$refs['fileInput-' + idx][0].click()"
                                                :disabled="isItemDisabled(item)"
                                                v-b-tooltip.hover
                                                title="UPLOAD IMAGES"
                                            >
                                                <b-icon icon="cloud-upload-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                            <div v-else style="position: relative; display: inline-block;">
                                                <img
                                                    :src="item.images[0].raw || item.images[0].url"
                                                    style="max-width: 40px; max-height: 40px; cursor: pointer;"
                                                    @click="showImagePreview(item)"
                                                    class="img-thumbnail"
                                                >
                                                <b-button
                                                    variant="danger"
                                                    size="xs"
                                                    :disabled="isItemDisabled(item)"
                                                    @click="removeImage(item, idx)"
                                                    style="position: absolute; top: -8px; right: -8px; padding: 0px 4px;"
                                                >
                                                    ×
                                                </b-button>
                                            </div>
                                            <b-button
                                                size="sm"
                                                variant="outline-primary"
                                                v-if="item.pictures && item.pictures.length"
                                                @click="showImages(item.pictures)"
                                                v-b-tooltip.hover
                                                title="SHOW IMAGES"
                                            >
                                                <b-icon icon="image-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                </div>
                <b-card-text v-else>
                    <b-alert show variant="primary">NO ITEMS ADDED TO THIS ORDER YET.</b-alert>
                </b-card-text>

                <div>
                    <div v-if="items.length > 0">
                        <b-button size="sm" variant="success" @click="save_customer_backorder_po_items">UPDATE</b-button>
                    </div>
                    <div v-else>
                        <b-button size="sm" variant="warning" @click="close_it">CANCEL</b-button>
                    </div>
                </div>
            </b-card-text>
        </b-card>

        <!-- Customer Backorder History Block -->
        <b-card v-if="customer_backorder_po_id" style="margin: 0px; margin-top: 10px; padding: 0px;" no-body>
            <b-alert show>CUSTOMER BACKORDER HISTORY</b-alert>

            <div v-if="filteredCustomerBackorderHistory.length > 0" class="diver">
                <b-card-text>
                    <table style="width: 100%;" class="text-monospace">
                        <thead>
                            <tr>
                                <td class="srr" style="width:80px">DATE</td>
                                <td class="srr" style="width:100px">SKU</td>
                                <td class="srr" style="width:300px">DESCRIPTION</td>
                                <td class="srr" style="width:100px">QTY ORD</td>
                                <td class="srr" style="width:100px">QTY RCVD</td>
                                <td class="srr" style="width:120px">STATUS</td>
                                <td class="srr" style="width:100px">CHANGED BY</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(historyItem, idx) in filteredCustomerBackorderHistory" :key="idx">
                                <td class="srrv">{{ historyItem.change_date }}</td>
                                <td class="srrv">{{ historyItem.product_sku }}</td>
                                <td class="srrv">{{ historyItem.item_description }}</td>
                                <td class="srrv">{{ historyItem.quantity_ordered }}</td>
                                <td class="srrv">{{ historyItem.quantity_received }}</td>
                                <td class="srrv">{{ historyItem.status_text }}</td>
                                <td class="srrv">{{ historyItem.changed_by }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-text>
            </div>

            <div v-else>
                <div v-if="historyLoading">
                    <loading :active="true" :can-cancel="false" :is-full-page="false"></loading>
                </div>
                <div v-else>
                    <b-card-text class="srrv">NO HISTORY FOR THIS CUSTOMER BACKORDER YET</b-card-text>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
    name: "CreateNewVendorPurchaseOrder",
    props: ["viewdata"],
    components: { flatPickr, Loading, DatePicker, VueSimpleSuggest },
    data: function() {
        return {
            packet: {},
            statuses: [
                { value: 1, text: "NEW" },
                { value: 2, text: "ORDERED" },
                { value: 3, text: "SCHEDULED" },
                { value: 4, text: "IN-TRANSIT" },
                { value: 5, text: "PARTIAL" },
                { value: 6, text: "RECEIVED" },
                { value: 7, text: "COMPLETED" },
                { value: 8, text: "ARCHIVED" },
            ],
            customer_backorder_po_id: null,
            customer_backorder_po_vendor_id: null,
            vendor_id: null,
            eta: null,
            po_number: null,
            items: [],
            products: [],
            loading: null,
            receiving_location_id: null,
            images: [],
            customerBackorderHistory: [],
            historyLoading: false,
            mainScheduleDate: null,
            mainReceivingLocation: null,
            autoApplyMainDate: true,
        }
    },
    computed: {
        filteredLocationsWithDefault() {
            if (!this.receiving_location_id || !this.packet.locsubs) return [];

            const receivingLoc = this.receiving_location_id.toString();

            let locations;
            if (this.packet.locations && this.packet.locations.find(loc => loc.value == this.receiving_location_id && loc.is_main_warehouse)) {
                locations = this.packet.locsubs.filter(item =>
                    [this.receiving_location_id].includes(item.location_id) &&
                    ["CUSTOMER VENDOR ORDERS"].includes(item.sublocation)
                );
            } else {
                locations = this.packet.locsubs.filter(loc => {
                    return loc.value.toString().startsWith(receivingLoc + '|') ||
                        loc.value.toString() === receivingLoc;
                });
            }

            return locations;
        },
        filteredCustomerBackorderHistory() {
            if (!this.customerBackorderHistory || this.customerBackorderHistory.length === 0) return [];

            const uniqueEntries = new Map();
            const filteredHistory = [];

            for (let i = this.customerBackorderHistory.length - 1; i >= 0; i--) {
                const item = this.customerBackorderHistory[i];
                const key = `${item.product_sku}-${item.quantity_ordered}-${item.quantity_received}-${item.status_text}-${item.drop_location_name || item.drop_location}`;

                if (!uniqueEntries.has(key)) {
                    uniqueEntries.set(key, true);
                    filteredHistory.unshift(item);
                }
            }

            return filteredHistory;
        },
        isWarehouseUser() {
            return this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser';
        },
        filteredLocations() {
            if (!this.receiving_location_id || !this.packet.locsubs) return [];

            const receivingLoc = this.receiving_location_id.toString();

            if (this.packet.locations && this.packet.locations.find(loc => loc.value == this.receiving_location_id && loc.is_main_warehouse)) {
                return this.packet.locsubs.filter(item =>
                    [this.receiving_location_id].includes(item.location_id) &&
                    ["CUSTOMER VENDOR ORDERS"].includes(item.sublocation)
                )
            }

            return this.packet.locsubs.filter(loc => {
                return loc.value.toString().startsWith(receivingLoc + '|') ||
                    loc.value.toString() === receivingLoc;
            });
        },
        filteredStatuses() {
            const disabledStatuses = ["ORDERED", "RECEIVED", "PARTIAL"];
            if (this.packet.userDetails.userrole !== 'admin') {
                return this.statuses.map(status => ({
                    ...status,
                    disabled: !disabledStatuses.includes(status.text),
                }));
            }
            return this.statuses;
        }
    },
    methods: {
        // Auto-apply receiving location to all items
        applyMainReceivingLocation() {
            if (!this.mainReceivingLocation) return;

            let appliedCount = 0;
            this.items.forEach(item => {
                if (!this.isItemDisabled(item) && ![6, 7, 8].includes(item.status)) {
                    item.locsub = this.mainReceivingLocation;
                    appliedCount++;
                }
            });

            if (appliedCount > 0) {
                this.$bvToast.toast(
                    `Receiving location applied to ${appliedCount} item(s)`,
                    { title: "Auto-Applied", autoHideDelay: 2000, variant: "success" }
                );
            }
        },

        // Auto-apply schedule date to all items
        applyMainScheduleDate() {
            if (!this.mainScheduleDate) return;

            let appliedCount = 0;
            this.items.forEach(item => {
                if (!this.isItemDisabled(item) && item.status !== 6) {
                    item.schedule_date = this.mainScheduleDate;
                    item.userModifiedScheduleDate = false;
                    if (item.status !== 3) {
                        item.status = 3;
                    }
                    if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                        item.quantity_scheduled = item.quantity_ordered;
                    }
                    appliedCount++;
                }
            });

            this.$bvToast.toast(
                `Schedule date applied to ${appliedCount} item(s)`,
                { title: "Auto-Applied", autoHideDelay: 2000, variant: "success" }
            );
        },

        getScheduledQuantityState(item) {
            if (item.status === 6) {
                return item.quantity_scheduled === item.quantity_ordered;
            }
            return null;
        },
        getMinScheduledQuantity(item) {
            if (item.status === 6) {
                return item.quantity_ordered;
            }
            if (item.status === 3) {
                return 1;
            }
            return 0;
        },
        validateScheduledQuantity(item) {
            this.$nextTick(() => {
                let scheduled = Number(item.quantity_scheduled) || 0;

                if (scheduled < 0) scheduled = 0;
                if (scheduled > item.quantity_ordered) scheduled = item.quantity_ordered;

                item.quantity_scheduled = scheduled;

                if (item.status === 6 && scheduled !== item.quantity_ordered) {
                    item.quantity_scheduled = item.quantity_ordered;
                    this.$bvToast.toast(
                        "Scheduled quantity auto-adjusted to match ordered quantity for received item",
                        { title: "Validation", autoHideDelay: 2000, variant: "info" }
                    );
                }
            });
        },

        getLocationState(item) {
            if ([5, 6].includes(item.status)) {
                if (!item.locsub || item.locsub === '' || item.locsub === null || item.locsub === undefined) {
                    return false;
                }
            }
            return null;
        },
        isScheduleDateFromMain(item) {
            return item.hasMainScheduleDate && !item.userModifiedScheduleDate;
        },
        fetchCustomerBackorderHistory: function() {
            let data = { id: this.customer_backorder_po_id }
            let path = "/api/customer_backorder/get_customer_backorder_history/"
            let that = this;
            let s = function(response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        "ERROR RETRIEVING CUSTOMER BACKORDER HISTORY",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                } else {
                    that.customerBackorderHistory = response.data.result;
                }
                that.historyLoading = false;
            }

            let f = function(error) {
                that.$bvToast.toast(
                    "ERROR OCCURRED WITH HISTORY. PLEASE TRY LATER.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.historyLoading = false;
            }
            this.historyLoading = true;
            Requestor.getSyncP(path, data, this, s, f);
        },

        proceedWithSave: function(saveData) {
            let that = this;
            let path = "/api/customer_backorder/save_customer_backorder_po_items/"

            let itemsWithDiffs = saveData.items.map(item => ({
                ...item,
                quantity_difference: item.quantity_received - (item.original_quantity_received || 0)
            }));

            let data = {
                customer_backorder_po_id: saveData.customer_backorder_po_id,
                items: itemsWithDiffs,
                created_by: saveData.created_by,
                location_id: saveData.location_id
            };

            this.loading = true;
            Requestor.postSyncP(
                path,
                data,
                this,
                function(response) {
                    that.loading = false;
                    if (response.data.error) {
                        that.$bvToast.toast(response.data.error, {
                            title: "Error",
                            variant: "warning",
                            autoHideDelay: 1500
                        });
                    } else {
                        that.$bvToast.toast("SAVED", {
                            title: "Success",
                            variant: "success",
                            autoHideDelay: 1500
                        });
                        that.fetch_init();
                        that.fetchCustomerBackorderHistory();
                    }
                },
                function(error) {
                    that.loading = false;
                    that.$bvToast.toast("Error occurred. Please try again.", {
                        title: "Error",
                        variant: "danger",
                        autoHideDelay: 1500
                    });
                    console.error(error);
                }
            );
        },
        statusColors() {
            return {
                1: '#f8f9fa',
                2: '#e3f2fd',
                3: '#fff3e0',
                4: '#fff9c4',
                5: '#ffecb3',
                6: '#c8e6c9',
                7: '#c8e6c9',
                8: '#f5f5f5'
            };
        },
        getStatusColor(status) {
            return this.statusColors()[status] || '#ffffff';
        },
        handleScheduleDateChange(item) {
            item.userModifiedScheduleDate = true;
            if (item.schedule_date && item.status !== 6) {
                item.status = 3;
                if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                    item.quantity_scheduled = item.quantity_ordered;
                }
            }
        },

        showImages(pictures) {
            pictures.forEach(pic => {
                if (pic.url) {
                    window.open(pic.url, '_blank');
                }
            });
        },
        getImageSrc(image) {
            return image.raw || image.url || '';
        },

        handleImageUpload(event, item, idx) {
            const input = event.target;
            if (input.files && input.files[0]) {
                const img = { raw: "", url: "", file: null };
                const reader = new FileReader();

                reader.onload = (e) => {
                    img.raw = e.target.result;
                    if (!item.images) this.$set(item, 'images', []);
                    item.images = [img];
                    this.$set(this.items, idx, item);
                };

                img.file = input.files[0];
                reader.readAsDataURL(input.files[0]);
            }
        },

        removeImage(item, idx) {
            item.images = [];
            this.$refs['fileInput-' + idx][0].value = '';
            this.$set(this.items, idx, item);
        },

        showImagePreview(item) {
            if (!item.images || item.images.length === 0) return;

            const image = item.images[0];
            this.$bvModal.msgBoxOk('', {
                title: 'Image Preview',
                centered: true,
                size: 'lg',
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyClass: 'text-center',
                content: () => (
                    <div>
                        <img src={this.getImageSrc(image)} style="max-width: 100%; max-height: 70vh;" alt="Item Image" />
                    </div>
                )
            });
        },
        preventInvalidEntry(event, item) {
            const allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46];
            if (allowedKeys.includes(event.keyCode)) return;

            const currentValue = event.target.value;
            const newValue = currentValue.slice(0, event.target.selectionStart) +
                            currentValue.slice(event.target.selectionEnd);

            const min = this.getMinQuantity(item);
            const max = item.quantity_ordered;

            if (newValue !== '' && (isNaN(newValue) ||
                parseInt(newValue) < min ||
                parseInt(newValue) > max)) {
                event.preventDefault();
            }
        },

        getLocationName(locId) {
            const loc = this.packet.locsubs.find(l => l.value.toString() === locId.toString());
            return loc ? loc.text : 'Location ' + locId;
        },

        getMinQuantity(item) {
            return item.original_quantity_received || 0;
        },

        getMinScheduledQuantity(item) {
            if (item.status == 3) {
                return 1;
            }
            return 0;
        },

        isItemDisabled(item) {
            return item.original_status === 6;
        },

        isItemDisabled2(item) {
            if (this.packet.userDetails.userrole !== 'admin') {
                return true;
            }
        },
        getStatusState(item) {
            if (item.quantity_received > 0) {
                return [5, 6].includes(item.status) ? null : false;
            }
            return null;
        },

        validateQuantity(item) {
            const min = this.getMinQuantity(item);
            const max = item.quantity_ordered;
            const maxScheduled = item.quantity_scheduled;

            this.$nextTick(() => {
                let received = Number(item.quantity_received) || 0;

                if (received < min) {
                    received = min;
                } else if (received > max) {
                    received = max;
                } else if (received > maxScheduled) {
                    received = maxScheduled;
                    this.$bvToast.toast(
                        "Receiving quantity cannot exceed scheduled quantity",
                        { title: "Validation", autoHideDelay: 2000, variant: "warning" }
                    );
                }

                item.quantity_received = received;

                if (received > 0) {
                    if (received === max) {
                        item.status = 6;
                        item.receiving_date = moment().format('MM-DD-YYYY');
                        if (item.quantity_scheduled !== item.quantity_ordered) {
                            item.quantity_scheduled = item.quantity_ordered;
                        }
                    } else {
                        item.status = 5;
                    }
                } else {
                    item.status = null;
                    item.receiving_date = null;
                }
            });
        },

        handleStatusChange(item) {
            if (item.status === 3) {
                item.schedule_date = moment().format('MM-DD-YYYY');
                if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                    item.quantity_scheduled = item.quantity_ordered;
                }
            }

            if (item.status === 6 && item.quantity_scheduled !== item.quantity_ordered) {
                this.$bvToast.toast(
                    "Scheduled quantity must equal ordered quantity when marking as received",
                    { title: "Validation Error", autoHideDelay: 3000, variant: "danger" }
                );
                this.$nextTick(() => {
                    item.status = item.original_status || 1;
                });
                return;
            }

            if ([5, 6].includes(item.status)) {
                if (!item.locsub || item.locsub === '' || item.locsub === null || item.locsub === undefined) {
                    this.$bvToast.toast(
                        "Please select a receiving location before marking as partial or received",
                        { title: "Validation Error", autoHideDelay: 3000, variant: "danger" }
                    );
                    this.$nextTick(() => {
                        item.status = item.original_status || 1;
                    });
                    return;
                }
            }

            if (item.status === 6) {
                if (!item.locsub) {
                    this.$bvToast.toast(
                        "Please select a receiving location before marking as received",
                        { title: "Validation Error", autoHideDelay: 3000, variant: "danger" }
                    );
                    this.$nextTick(() => {
                        item.status = item.original_status || 1;
                    });
                    return;
                }

                item.quantity_received = item.quantity_ordered;
                item.receiving_date = moment().format('MM-DD-YYYY');
            } else if (item.status === 5 && item.quantity_received === 0) {
                item.quantity_received = this.getMinQuantity(item) || 1;
            }

            if (item.status === 3 && item.quantity_scheduled < 1) {
                item.quantity_scheduled = 1;
            }

            if (item.original_status === 6 && item.status !== 6) {
                item.receiving_date = null;
            }
        },

        validate: function(data) {
            let errors = [];

            for (let i = 0; i < data.items.length; i++) {
                const item = data.items[i];
                const quantity_received = item.quantity_received;
                const quantity_ordered = item.quantity_ordered;
                const status = item.status;
                const originalQuantityReceived = item.original_quantity_received || 0;

                if (status === 6) {
                    if (item.quantity_scheduled !== item.quantity_ordered) {
                        errors.push({
                            message: `SCHEDULED QUANTITY (${item.quantity_scheduled}) MUST EQUAL ORDERED QUANTITY (${item.quantity_ordered}) WHEN STATUS IS "RECEIVED" FOR ITEM ${i + 1}.`
                        });
                    }
                }

                if (item.quantity_scheduled !== undefined && item.quantity_scheduled !== null &&
                    item.quantity_received > item.quantity_scheduled) {
                    errors.push({
                        message: `QUANTITY RECEIVED (${item.quantity_received}) CANNOT EXCEED SCHEDULED QUANTITY (${item.quantity_scheduled}) FOR ITEM ${i + 1}.`
                    });
                }

                if (item.quantity_received === undefined || item.quantity_received === null) {
                    errors.push({ message: "PLEASE SPECIFY A QUANTITY RECEIVED FOR EACH ITEM." });
                } else if (isNaN(item.quantity_received)) {
                    errors.push({ message: "QUANTITY RECEIVED MUST BE A VALID NUMBER." });
                } else if (item.quantity_received < 0) {
                    errors.push({ message: "QUANTITY RECEIVED CANNOT BE NEGATIVE." });
                }

                if ([5, 6].includes(item.status)) {
                    if (!item.locsub || item.locsub === '' || item.locsub === null || item.locsub === undefined) {
                        errors.push({
                            message: `ITEM ${i + 1}: RECEIVING LOCATION IS REQUIRED FOR PARTIAL OR RECEIVED STATUS.`
                        });
                    }
                }

                if ([6].includes(status)) {
                    if (!item.receiving_date) {
                        errors.push({
                            message: `ITEM ${i + 1}: RECEIVING DATE IS REQUIRED FOR PARTIAL OR RECEIVED STATUS.`
                        });
                    }
                }

                if (item.status === 3 && !item.schedule_date) {
                    errors.push({
                        message: `ITEM ${i + 1}: SCHEDULE DATE IS REQUIRED FOR SCHEDULED STATUS.`
                    });
                }

                if (item.status === 3 && (!item.quantity_scheduled || item.quantity_scheduled === 0)) {
                    errors.push({
                        message: `ITEM ${i + 1}: SCHEDULED QUANTITY IS REQUIRED FOR SCHEDULED STATUS.`
                    });
                }

                if (item.quantity_received > 0 && ![5, 6].includes(status)) {
                    errors.push({
                        message: `STATUS MUST BE "PARTIAL" OR "RECEIVED" WHEN QUANTITY IS RECEIVED FOR ITEM ${i + 1}.`
                    });
                }

                if (item.quantity_ordered !== undefined && item.quantity_ordered !== null && item.quantity_received > item.quantity_ordered) {
                    errors.push({
                        message: `QUANTITY RECEIVED (${item.quantity_received}) CANNOT EXCEED ORDERED QUANTITY (${item.quantity_ordered}) FOR ITEM ${i + 1}.`
                    });
                }

                if (originalQuantityReceived === 0) {
                    if (item.quantity_received > 0 && item.quantity_received < item.quantity_ordered) {
                        if (status !== 5) {
                            errors.push({
                                message: `STATUS MUST BE "PARTIAL" WHEN RECEIVING PARTIAL QUANTITY (${item.quantity_received} OF ${item.quantity_ordered}) FOR ITEM ${i + 1}.`
                            });
                        }
                    } else if (item.quantity_received === item.quantity_ordered) {
                        if (status !== 6) {
                            errors.push({
                                message: `STATUS MUST BE "RECEIVED" WHEN FULL QUANTITY IS RECEIVED FOR ITEM ${i + 1}.`
                            });
                        }
                    }
                }

                if (status === 6) {
                    if (item.quantity_received === 0) {
                        errors.push({
                            message: `QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "RECEIVED" FOR ITEM ${i + 1}.`
                        });
                    } else if (item.quantity_received < item.quantity_ordered) {
                        errors.push({
                            message: `STATUS CANNOT BE "RECEIVED" IF QUANTITY RECEIVED (${item.quantity_received}) < ORDERED QUANTITY (${item.quantity_ordered}). USE "PARTIAL" INSTEAD.`
                        });
                    }
                } else if (status === 5) {
                    if (item.quantity_received === 0) {
                        errors.push({
                            message: `QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "PARTIAL" FOR ITEM ${i + 1}.`
                        });
                    } else if (item.quantity_received >= item.quantity_ordered) {
                        errors.push({
                            message: `STATUS CANNOT BE "PARTIAL" IF QUANTITY RECEIVED (${item.quantity_received}) ≥ ORDERED QUANTITY (${item.quantity_ordered}). USE "RECEIVED" INSTEAD.`
                        });
                    }
                }
            }

            return errors;
        },
        save_customer_backorder_po_items: function() {
            let saveData = {
                customer_backorder_po_id: this.customer_backorder_po_id,
                items: this.items.filter(item => item.original_status !== 6),
                created_by: this.packet.userDetails.username,
                location_id: this.packet.userDetails.properties.location_id
            };

            const invalidScheduledItems = this.items.filter(item =>
                item.status === 6 && item.quantity_scheduled !== item.quantity_ordered
            );

            if (invalidScheduledItems.length > 0) {
                this.$bvToast.toast(
                    "Items marked as Received must have scheduled quantity equal to ordered quantity",
                    { title: "Validation Error", autoHideDelay: 3000, variant: "warning" }
                );
                return;
            }

            if (saveData.items.length === 0) {
                return this.$bvToast.toast(
                    "No Items to Save or All Items are marked as Received",
                    { title: "No Items to Save", autoHideDelay: 2500, variant: "warning" }
                );
            }

            if (saveData.items.some(item => item.quantity_ordered === item.quantity_received && (Number(item.status) !== 6))) {
                return this.$bvToast.toast(
                    "Items with equal Ordered Quantity and Received Quantity must be marked as Received",
                    { title: "Invalid Status", autoHideDelay: 3000, variant: "warning" }
                );
            }

            if (saveData.items.some(item => item.quantity_ordered !== item.quantity_received && (Number(item.status) === 6))) {
                return this.$bvToast.toast(
                    "Items can't be marked as Received unless the Ordered quantity and Received Quantity become Equal",
                    { title: "Invalid Status", autoHideDelay: 3000, variant: "warning" }
                );
            }

            let errors = this.validate(saveData);
            if (errors.length > 0) {
                this.$vex.dialog.alert({ message: errors[0].message });
                return;
            }

            const needsReceivedConfirmation = this.items.some(item =>
                item.quantity_received === item.quantity_ordered && item.status !== 6
            );

            if (needsReceivedConfirmation) {
                this.$vex.dialog.confirm({
                    message: 'Some items have full quantity received but are not marked as "Received". Update status to "Received"?',
                    callback: (confirmed) => {
                        if (confirmed) {
                            this.items.forEach(item => {
                                if (item.quantity_received === item.quantity_ordered) {
                                    item.status = 6;
                                }
                            });
                            saveData.items = this.items.filter(item => item.original_status !== 6);
                            this.proceedWithSave(saveData);
                        }
                    }
                });
            } else {
                const needsConfirmation = this.items.some(item =>
                    item.status == 6 || item.status == 5
                );

                if (needsConfirmation) {
                    this.$vex.dialog.confirm({
                        message: 'You are marking items as RECEIVED or PARTIAL. This will update inventory. Continue?',
                        callback: (confirmed) => {
                            if (confirmed) {
                                this.proceedWithSave(saveData);
                            }
                        }
                    });
                } else {
                    this.proceedWithSave(saveData);
                }
            }
        },
        add_custom_item: function(e) {
            let idx = this.items.length;
            let item = {
                idx: idx + 1,
                product_sku: null,
                product_name: null,
                invoice_id: null,
                category_id: null,
                vendor_id: this.vendor_id,
                cubes: null,
                quantity: null,
                fob_price: null,
                selling_price: null,
                landed_cost: null,
                wholesale_price: null,
                product_type: 2,
                receiving_location_id: null,
                receiving_sublocation_id: null,
                comments: null,
                original_status: null,
                created_by: this.packet.userDetails.username,
            }
            this.items.push(item);
        },
        add_item: function(e) {
            if (this.items.filter(function(d) { return d.product_sku == e.product_sku }).length > 0) {
                return
            }

            const defaultSubLocation = this.filteredLocations.length > 0
                ? this.filteredLocations[0].value
                : this.receiving_location_id;

            let idx = this.items.length;
            let item = {
                idx: idx + 1,
                product_sku: e.product_sku,
                product_name: e.product_name,
                category_id: e.category_id,
                vendor_id: e.vendor_id,
                cubes: e.cubes,
                invoice_id: e.invoice_id || null,
                quantity_ordered: null,
                quantity_scheduled: null,
                quantity_received: null,
                locsub: defaultSubLocation,
                product_type: e.product_type,
                receiving_date: null,
                schedule_date: this.mainScheduleDate || null,
                color: null,
                customer_backorder_po_id: this.customer_backorder_po_id,
                comments: null,
                original_status: e.status,
                hasMainScheduleDate: !!this.mainScheduleDate,
                userModifiedScheduleDate: false,
            }
            this.items.push(item);
        },
        remove_item: function(product_sku) {
            this.items = this.items.filter(function(d) { return d.product_sku != product_sku });
        },
        filter_products: function(item, query) {
            return (
                item.product_name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                item.product_sku.toLowerCase().indexOf(query.toLowerCase()) > -1
            )
        },
        fetch_init: function() {
            let data = { customer_backorder_po_id: this.customer_backorder_po_id }
            let path = "/api/customer_backorder/get_customer_backorder_po_items/"
            let that = this;
            let s = function(response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        "ERROR RETRIEVING CUSTOMER BACKORDER ITEMS",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                } else {
                    that.receiving_location_id = response.data.receiving_location;
                    that.items = response.data.result.map(item => {
                        item.original_quantity_received = item.quantity_received || 0;
                        item.original_status = item.status;
                        item.images = item.pictures || [];
                        item.hasMainScheduleDate = !!item.schedule_date;
                        item.userModifiedScheduleDate = false;

                        that.$nextTick(() => {
                            if (!item.locsub && that.filteredLocations.length > 0) {
                                item.locsub = that.filteredLocations[0].value;
                            }
                        });

                        if (item.status) {
                            item.original_status = item.status;
                        }
                        if (item.quantity_received) {
                            item.original_quantity_received = item.quantity_received;
                        }
                        return item;
                    });
                }
                that.loading = false;
            }
            let f = function(error) {
                that.$bvToast.toast(
                    "Error retrieving products.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.loading = false;
            }
            this.loading = true;
            Requestor.getSyncP(path, data, this, s, f);
        },
        fetch_prereqs: function() {
            console.log("Fetching products...");
            if (this._productsRequested) return;
            this._productsRequested = true;

            let data = {};
            let path = "/api/product/get_product_list_v5/";
            let that = this;

            let s = function(response) {
                if (response.data.error) {
                    console.error("Error fetching products:", response.data.error);
                    that.products = [];
                } else {
                    console.log("Raw products received:", response.data.result);
                    that.products = response.data.result || [];
                    that.products = that.products.filter(function(d) {
                        return d.vendor_id == that.stock_order_vendor_id;
                    });
                    that.fetch_init();
                }
                that.loading = false;
            };

            let f = function(error) {
                that.$bvToast.toast(
                    "Error retrieving products.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.loading = false;
            }
            this.loading = true;
            Requestor.getSyncP(path, data, this, s, f);
        },
        filter_products_for_vendor: function() {
            let that = this;
            this.vendor_products = this.products.filter(function(d) { return d.vendor_id == that.vendor_id });
        },
        close_it: function() {
            this.$emit("done-items-so", this.items);
        }
    },
    watch: {
        mainScheduleDate(newDate) {
            if (newDate && this.autoApplyMainDate) {
                this.applyMainScheduleDate();
            }
        },
        mainReceivingLocation(newLocation) {
            if (newLocation) {
                this.applyMainReceivingLocation();
            }
        },
        customer_backorder_po_id: function(newVal) {
            if (newVal) {
                this.fetchCustomerBackorderHistory();
            }
        }
    },
    created: function() {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
        this.customer_backorder_po_id = JSON.parse(JSON.stringify(this.viewdata)).customer_backorder_po_id;
        this.customer_backorder_po_vendor_id = JSON.parse(JSON.stringify(this.viewdata)).customer_backorder_po_vendor_id;
        this.read_only = JSON.parse(JSON.stringify(this.viewdata)).read_only;
    },
    mounted: function() {
        this.fetch_prereqs();
        if (this.read_only != true) {
            this.fetch_prereqs();
        }
        if (this.customer_backorder_po_id) {
            this.fetchCustomerBackorderHistory();
        }

        this.$nextTick(() => {
            if (this.filteredLocationsWithDefault && this.filteredLocationsWithDefault.length > 0) {
                this.mainReceivingLocation = this.filteredLocationsWithDefault[0].value;
            }
        });
    },
}
</script>

<style scoped>
.date-picker-container {
    position: relative;
    display: inline-block;
}

.eta-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 10;
    font-size: 8px;
    padding: 2px 4px;
}

.date .input-group-text {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
}

.diver {
    overflow: auto;
    width: 100%;
    padding-bottom: 20px;
    position: relative;
}

table {
    table-layout: fixed;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.srr {
    font-size: 11px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
}

.srrv {
    font-size: 11px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

/* Sticky columns for first two columns (INVOICE # and CATEGORY) */
.srrv:first-of-type,
thead .srr:first-of-type {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 1;
}

thead .srr:first-of-type {
    background-color: #efefef;
    z-index: 3;
}

.srrv:nth-of-type(2),
thead .srr:nth-of-type(2) {
    position: sticky;
    left: 100px;
    background-color: white;
    z-index: 2;
}

thead .srr:nth-of-type(2) {
    background-color: #efefef;
    z-index: 3;
}

tbody tr .srrv:first-of-type,
tbody tr .srrv:nth-of-type(2) {
    background-color: white;
}

.srrv:first-of-type,
.srrv:nth-of-type(2),
thead .srr:first-of-type,
thead .srr:nth-of-type(2) {
    box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.15);
}

.mx-input {
    font-size: 12px;
}

/* Status color styles */
.status-new { background-color: #f8f9fa; color: black; }
.status-ordered { background-color: #e3f2fd; color: black; }
.status-scheduled { background-color: #e1f5fe; color: black; }
.status-in-transit { background-color: #fff3e0; color: black; }
.status-partial { background-color: #fff9c4; color: black; }
.status-received { background-color: #c8e6c9; color: black; }
.status-completed { background-color: #1b5e20; color: white; }
.status-archived { background-color: #f5f5f5; color: black; }

/* Validation error styles */
.has-error .b-form-input,
.is-invalid {
    border-color: #dc3545;
    background-color: #fff8f8;
}

.invalid-feedback,
.b-form-invalid-feedback {
    color: #dc3545;
    font-size: 10px;
    margin-top: 2px;
}

/* Input focus styles */
.b-form-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Button styles */
.btn-group-sm > .btn,
.btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
}

/* Image thumbnail styles */
.img-thumbnail {
    padding: 2px;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    max-width: 40px;
    max-height: 40px;
}

/* Toast customization */
.toast {
    font-size: 12px;
}

/* Date picker customization */
.mx-datepicker {
    width: 100%;
}

.mx-input-wrapper .mx-input {
    padding: 4px 8px;
    font-size: 11px;
    height: auto;
}

/* Select dropdown customization */
.custom-select-sm {
    font-size: 11px;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 1.5rem 0.25rem 0.5rem;
}

/* Loading overlay */
.vld-overlay {
    background: rgba(255, 255, 255, 0.7);
}

.vld-icon {
    color: #007bff;
}

/* Badge styles */
.badge-info {
    background-color: #17a2b8;
    color: white;
    font-size: 9px;
    padding: 2px 4px;
}

/* Alert styles */
.alert {
    padding: 0.5rem 0.75rem;
    font-size: 12px;
    margin-bottom: 10px;
}

/* Card header styles */
.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 0.5rem 1rem;
}

/* Flex utilities */
.d-flex {
    display: flex !important;
}
.justify-content-between {
    justify-content: space-between !important;
}
.align-items-center {
    align-items: center !important;
}
.justify-content-center {
    justify-content: center !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}
.flex-nowrap {
    flex-wrap: nowrap !important;
}

/* Gap utility */
.gap-5 {
    gap: 5px;
}
.mr-3 {
    margin-right: 1rem !important;
}
.mr-2 {
    margin-right: 0.5rem !important;
}
.ml-2 {
    margin-left: 0.5rem !important;
}
.mb-0 {
    margin-bottom: 0 !important;
}
.py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.text-nowrap {
    white-space: nowrap;
}
.text-monospace {
    font-family: monospace;
}

/* Responsive styles */
@media screen and (max-width: 768px) {
    .diver {
        height: auto;
        overflow-x: auto;
        overflow-y: auto;
    }

    .srrv:first-of-type,
    .srrv:nth-of-type(2),
    thead .srr:first-of-type,
    thead .srr:nth-of-type(2) {
        box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.2);
    }
}

/* Print styles */
@media print {
    .srrv:first-of-type,
    .srrv:nth-of-type(2),
    thead .srr:first-of-type,
    thead .srr:nth-of-type(2) {
        position: static;
        box-shadow: none;
    }
    .diver {
        overflow: visible;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/CustomerBackOrderItems.vue